import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";

export const useDeleteExercise = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (id: number) =>
      // @ts-ignore
      api("DELETE /exercises/{id}", { params: [id], root: supportApiBase }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.getExercises());
      },
    }
  );
};
